export const generateTokenFromProtoken = (url) => {
  if (!url) return;
  const regex = /^cyberking:\/\/token\/(.+)$/;
  const match = url.match(regex);
  const token = match ? match[1] : null;
  return token;
};
